var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,23c0-0.6,0-1.3,0-2c0.1-1.7,0.7-3.3,1.7-4.6c1.3-1.7,2.9-2.9,5-3.5c2.2-0.6,4.2-0.4,6.2,0.6 c2.7,1.3,4.4,3.5,5,6.4c0.2,0.9,0.2,1.8,0.2,2.7c0,0.1,0,0.3,0,0.4C15,23,9,23,3,23z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M16.9,6.3c-0.1,1.8-0.8,3.4-2.4,4.4s-3.8,0.9-5.3-0.2c-1.6-1.3-2.3-3-2-5c0.2-1.8,1.1-3.1,2.7-3.9c1.7-0.8,3.3-0.7,4.8,0.4 C16.2,3,16.8,4.5,16.9,6.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.931514aab4d5ce9a020aa054fff68510.svg";
export { ForwardRef as ReactComponent };